var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHumidity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#78C081"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.091 6.17c-1.5-1.827-3.05-3.713-4.3-5.74A.929.929 0 0 0 11 0a.923.923 0 0 0-.788.43C8.962 2.455 7.41 4.343 5.91 6.17 2.87 9.869 0 13.363 0 17.5 0 23.29 4.934 28 11 28c6.067 0 11-4.71 11-10.5 0-4.135-2.87-7.63-5.909-11.33zM11 26.25c-5.054 0-9.167-3.925-9.167-8.75 0-3.533 2.68-6.795 5.52-10.252C8.594 5.74 9.866 4.191 11 2.532c1.135 1.66 2.407 3.21 3.646 4.718 2.84 3.455 5.52 6.719 5.52 10.25 0 4.825-4.111 8.75-9.166 8.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 10.5c-1.516 0-2.75 1.178-2.75 2.625s1.234 2.625 2.75 2.625S11 14.572 11 13.125 9.766 10.5 8.25 10.5zm0 3.5c-.506 0-.917-.392-.917-.875s.411-.875.917-.875.917.392.917.875S8.756 14 8.25 14zM13.75 19.25c-1.516 0-2.75 1.178-2.75 2.625s1.234 2.625 2.75 2.625 2.75-1.178 2.75-2.625-1.234-2.625-2.75-2.625zm0 3.5c-.504 0-.917-.394-.917-.875s.413-.875.917-.875.917.394.917.875-.413.875-.917.875zM16.23 12.507a.948.948 0 0 0-1.296 0l-9.166 8.75a.848.848 0 0 0 0 1.237c.18.17.414.256.649.256.234 0 .469-.086.647-.256l9.166-8.75a.848.848 0 0 0 0-1.237z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v28H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumidity);
export default __webpack_public_path__ + "static/media/humidity.de241e2f50b55829b0d99139dcbdb72c.svg";
export { ForwardRef as ReactComponent };